// extracted by mini-css-extract-plugin
export default {"wrapper":"performance-promise-module--wrapper--2a0be","text":"performance-promise-module--text--d21e9","icon":"performance-promise-module--icon--0996a"};